"use strict";

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin-top: ", ";\n  justify-content: center;\n  flex-direction: row;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfiniteScroller = exports.ScrollDirection = void 0;

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var LoadingIndicators_1 = require("./LoadingIndicators");

var LoadMoreContainer = styled_components_1["default"].div(_templateObject(), function (props) {
  return props.theme['@size-s'];
});
var ScrollDirection;

(function (ScrollDirection) {
  ScrollDirection[ScrollDirection["Vertical"] = 0] = "Vertical";
  ScrollDirection[ScrollDirection["Horizontal"] = 1] = "Horizontal";
})(ScrollDirection = exports.ScrollDirection || (exports.ScrollDirection = {}));

function InfiniteScroller(_ref) {
  var _scrollableTarget = _ref.scrollableTarget,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? ScrollDirection.Vertical : _ref$direction,
      loadMore = _ref.loadMore,
      hasMore = _ref.hasMore,
      children = _ref.children,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 0.5 : _ref$threshold,
      hideLoader = _ref.hideLoader;

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      fetchingMore = _ref3[0],
      setFetchingMore = _ref3[1];

  var fetchPromise = (0, react_1.useRef)();
  var scrollD = direction === ScrollDirection.Vertical ? 'scrollY' : 'scrollX';
  var scrollT = direction === ScrollDirection.Vertical ? 'scrollTop' : 'scrollLeft';
  var scrollH = direction === ScrollDirection.Vertical ? 'scrollHeight' : 'scrollWidth';
  var clientH = direction === ScrollDirection.Vertical ? 'clientHeight' : 'clientWidth';
  var innerH = direction === ScrollDirection.Vertical ? 'innerHeight' : 'innerWidth';
  (0, react_1.useEffect)(function () {
    var undo;

    var processScrollableTarget = function processScrollableTarget() {
      var target = typeof _scrollableTarget === 'function' ? _scrollableTarget() : _scrollableTarget || window;
      var scrollableTarget = typeof _scrollableTarget === 'function' ? _scrollableTarget() : _scrollableTarget;

      if (hasMore && target) {
        var onScroll = function onScroll() {
          var scrollY = scrollableTarget ? scrollableTarget[scrollT] : window[scrollD];
          var height = scrollableTarget ? scrollableTarget[scrollH] : window.document.body[scrollH];
          var containerHeight = scrollableTarget ? scrollableTarget[clientH] : window[innerH];
          scrollY += containerHeight;
          var thresholdPx = threshold * containerHeight;

          if (height - scrollY <= thresholdPx && !fetchPromise.current) {
            setFetchingMore(true);
            fetchPromise.current = loadMore()["catch"](function (err) {
              console.warn('Error occurred when fetching more.', err);
            }).then(function () {
              setTimeout(function () {
                setFetchingMore(false);
                fetchPromise.current = undefined;
              }, 100);
            });
          }
        };

        target.addEventListener('scroll', onScroll, {
          passive: true
        });
        return function () {
          return target.removeEventListener('scroll', onScroll);
        };
      } else {
        return false;
      }
    }; // Try to process it now. If it's not here, try again after a short delay.


    var result = processScrollableTarget();
    var interval;

    if (!result) {
      interval = setTimeout(function () {
        var result = processScrollableTarget();

        if (result) {
          undo = result;
        }
      }, 150);
    } else {
      undo = result;
    }

    return function () {
      if (undo) {
        undo();
      }

      clearInterval(interval);
    };
  }, [hasMore, _scrollableTarget, setFetchingMore, loadMore]);
  var loader = fetchingMore && !hideLoader ? react_1["default"].createElement(LoadMoreContainer, null, react_1["default"].createElement(LoadingIndicators_1.BlockSpin, null)) : null;
  return react_1["default"].createElement(react_1["default"].Fragment, null, children, loader);
}

exports.InfiniteScroller = InfiniteScroller;